import { render } from "./createCategory.vue?vue&type=template&id=72796f4e"
import script from "./createCategory.vue?vue&type=script&lang=js"
export * from "./createCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__